import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        // Sign out from Supabase - this clears all auth cookies/tokens
        const { error } = await supabase.auth.signOut();
        
        if (error) {
          console.error('Logout error:', error);
          toast.error('Error signing out');
        } else {
          toast.success('Successfully signed out');
        }
      } catch (error) {
        console.error('Unexpected logout error:', error);
        toast.error('Error signing out');
      } finally {
        // Always redirect to auth page regardless of success/failure
        navigate('/auth');
      }
    };

    handleLogout();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500 mx-auto mb-4"></div>
        <p className="text-muted-foreground">Signing out...</p>
      </div>
    </div>
  );
};

export default Logout;